export default "__VITE_ASSET__3180822c__"